export * from './FileFormatXmlIcon';
export * from './FileFormatXmlIcon16Light';
export * from './FileFormatXmlIcon16Regular';
export * from './FileFormatXmlIcon16Solid';
export * from './FileFormatXmlIcon20Light';
export * from './FileFormatXmlIcon20Regular';
export * from './FileFormatXmlIcon20Solid';
export * from './FileFormatXmlIcon24Regular';
export * from './FileFormatXmlIcon24Solid';
export * from './FileFormatXmlIcon32Regular';
export * from './FileFormatXmlIcon64Regular';
